<template>
	<a-modal
		:visible="visible"
		:footer="null"
		:closable="false"
		:mask-closable="false"
		:destroy-on-close="true"
		width="640px"
		:centered="true"
		wrap-class-name="g-contact-settings-modal"
		@cancel="onCancel"
	>
		<div class="g-contact-settings">
			<div class="g-contact-settings__header">
				<span class="g-contact-settings__title">联系方式模块</span>
				<span class="g-contact-settings__close mbm-iconfont mbm-guanbi1" @click="onCancel"></span>
			</div>

			<div class="g-contact-settings__form">
				<div class="g-contact-settings__field">
					<label class="g-contact-settings__label">标题</label>
					<input
						v-model="form.title"
						type="text"
						class="g-contact-settings__input"
						placeholder="例如名称、联系方式说明等，不填则不显示"
					/>
				</div>

				<div
					v-for="(phone, index) in form.phones"
					:key="`phone-${index}`"
					class="g-contact-settings__field"
				>
					<label class="g-contact-settings__label">电话</label>
					<div class="g-contact-settings__control">
						<input
							v-model="form.phones[index]"
							type="text"
							class="g-contact-settings__input"
							placeholder="不填则不显示"
						/>
						<button
							v-if="form.phones.length > 1"
							type="button"
							class="g-contact-settings__remove"
							@click="removePhone(index)"
						>删除</button>
					</div>
				</div>

				<div class="g-contact-settings__field is-action-only">
					<label class="g-contact-settings__label"></label>
					<button type="button" class="g-contact-settings__add-btn" @click="addPhone">
						<span class="g-contact-settings__add-icon">+</span>
						添加电话
					</button>
				</div>

				<div class="g-contact-settings__field">
					<label class="g-contact-settings__label">邮箱</label>
					<input
						v-model="form.email"
						type="text"
						class="g-contact-settings__input"
						placeholder="不填则不显示"
					/>
				</div>

				<div class="g-contact-settings__field">
					<label class="g-contact-settings__label">地址</label>
					<textarea
						v-model="form.address"
						class="g-contact-settings__textarea"
						rows="3"
						placeholder="不填则不显示"
					></textarea>
				</div>

				<div
					v-for="item in form.extraItems"
					:key="item.id"
					class="g-contact-settings__field"
				>
					<label class="g-contact-settings__label">{{ getExtraLabel(item.type) }}</label>
					<div class="g-contact-settings__control">
						<input
							v-model="item.value"
							type="text"
							class="g-contact-settings__input"
							placeholder="不填则不显示"
						/>
						<button
							type="button"
							class="g-contact-settings__remove"
							@click="removeExtraItem(item.id)"
						>删除</button>
					</div>
				</div>

				<div class="g-contact-settings__field is-action-only">
					<label class="g-contact-settings__label"></label>
					<div ref="addMenuWrap" class="g-contact-settings__add-menu-wrap">
						<button type="button" class="g-contact-settings__add-btn" @click="toggleAddMenu">
							<span class="g-contact-settings__add-icon">+</span>
							添加信息
						</button>
						<div v-if="addMenuVisible" class="g-contact-settings__add-menu">
							<button
								v-for="option in extraFieldOptions"
								:key="option.type"
								type="button"
								class="g-contact-settings__add-menu-item"
								@click="addExtraField(option.type)"
							>
								{{ option.label }}
							</button>
						</div>
					</div>
				</div>

				<div class="g-contact-settings__field">
					<label class="g-contact-settings__label">备注</label>
					<textarea
						v-model="form.remark"
						class="g-contact-settings__textarea"
						rows="3"
						placeholder="例如营业时间等其他说明，不填则不显示"
					></textarea>
				</div>
			</div>

			<div class="g-contact-settings__footer">
				<div class="g-contact-settings__footer-actions">
					<button type="button" class="g-contact-settings__btn is-cancel" @click="onCancel">取消</button>
					<button type="button" class="g-contact-settings__btn is-confirm" @click="onConfirm">确认</button>
				</div>
			</div>
		</div>
	</a-modal>
</template>

<script>
	import { v4 as uuidv4 } from 'uuid';
	import {
		CONTACT_EXTRA_FIELD_OPTIONS,
		getContactExtraFieldLabel,
		getContactInfoDefaults,
		normalizeContactInfoData,
	} from '../utils/contactInfo.js';

	export default {
		name: 'GContactSettingsModal',
		props: {
			visible: {
				type: Boolean,
				default: false,
			},
			value: {
				type: Object,
				default: () => getContactInfoDefaults(),
			},
		},
		emits: ['update:visible', 'confirm'],
		data() {
			return {
				form: getContactInfoDefaults(),
				addMenuVisible: false,
				extraFieldOptions: CONTACT_EXTRA_FIELD_OPTIONS,
			};
		},
		watch: {
			visible(value) {
				if (value) {
					this.initForm();
				} else {
					this.addMenuVisible = false;
				}
			},
		},
		mounted() {
			document.addEventListener('click', this.onDocumentClick);
		},
		beforeUnmount() {
			document.removeEventListener('click', this.onDocumentClick);
		},
		methods: {
			initForm() {
				const source = normalizeContactInfoData(this.value);
				this.form = {
					...source,
					phones: source.phones.length ? [...source.phones] : [''],
					extraItems: source.extraItems.map(item => ({ ...item })),
				};
			},
			getExtraLabel(type) {
				return getContactExtraFieldLabel(type);
			},
			addPhone() {
				this.form.phones.push('');
			},
			removePhone(index) {
				if (this.form.phones.length <= 1) return;
				this.form.phones.splice(index, 1);
			},
			toggleAddMenu() {
				this.addMenuVisible = !this.addMenuVisible;
			},
			onDocumentClick(event) {
				if (!this.addMenuVisible) return;
				const wrap = this.$refs.addMenuWrap;
				if (wrap && !wrap.contains(event.target)) {
					this.addMenuVisible = false;
				}
			},
			addExtraField(type) {
				this.form.extraItems.push({
					id: uuidv4(),
					type,
					value: '',
				});
				this.addMenuVisible = false;
			},
			removeExtraItem(id) {
				this.form.extraItems = this.form.extraItems.filter(item => item.id !== id);
			},
			onCancel() {
				this.$emit('update:visible', false);
			},
			onConfirm() {
				this.$emit('confirm', normalizeContactInfoData(this.form));
				this.$emit('update:visible', false);
			},
		},
	};
</script>

<style scoped lang="less">
	.g-contact-settings {
		display: flex;
		flex-direction: column;
		max-height: min(920px, calc(100vh - 180px));
	}

	.g-contact-settings__header {
		display: flex;
		align-items: center;
		justify-content: space-between;
		flex-shrink: 0;
		margin-bottom: 18px;
	}

	.g-contact-settings__title {
		font-size: 18px;
		font-weight: 600;
		color: #333;
	}

	.g-contact-settings__close {
		font-size: 16px;
		color: #999;
		cursor: pointer;
		line-height: 1;

		&:hover {
			color: #666;
		}
	}

	.g-contact-settings__form {
		display: flex;
		flex: 1;
		flex-direction: column;
		gap: 14px;
		min-height: 0;
		overflow-x: hidden;
		overflow-y: auto;
		scrollbar-width: none;
		-ms-overflow-style: none;
		max-height: 600px;
		&::-webkit-scrollbar {
			display: none;
			width: 0;
			height: 0;
		}
	}

	.g-contact-settings__field {
		display: flex;
		align-items: flex-start;
		gap: 12px;

		&.is-action-only {
			margin-top: -6px;
		}
	}

	.g-contact-settings__label {
		flex-shrink: 0;
		width: 48px;
		padding-top: 8px;
		font-size: 14px;
		color: #666;
		line-height: 1.4;
		text-align: right;
	}

	.g-contact-settings__control {
		flex: 1;
		min-width: 0;
		display: flex;
		align-items: center;
		gap: 8px;
	}

	.g-contact-settings__input,
	.g-contact-settings__textarea {
		flex: 1;
		min-width: 0;
		padding: 8px 12px;
		border: 1px solid #d9d9d9;
		border-radius: 4px;
		font-size: 14px;
		color: #333;
		line-height: 1.5;
		outline: none;
		box-sizing: border-box;
		resize: vertical;

		&:focus {
			border-color: #285af9;
		}

		&::placeholder {
			color: #bbb;
		}
	}

	.g-contact-settings__textarea {
		min-height: 72px;
	}

	.g-contact-settings__add-btn {
		display: inline-flex;
		align-items: center;
		gap: 4px;
		padding: 0;
		border: none;
		background: transparent;
		font-size: 13px;
		color: #285af9;
		line-height: 1.4;
		cursor: pointer;
		outline: none;
	}

	.g-contact-settings__add-icon {
		font-size: 16px;
		line-height: 1;
	}

	.g-contact-settings__add-menu-wrap {
		position: relative;
	}

	.g-contact-settings__add-menu {
		position: absolute;
		top: -265px;
		left: -20px;
		z-index: 2;
		min-width: 120px;
		padding: 6px 0;
		border: 1px solid #eee;
		border-radius: 4px;
		background: #fff;
		box-shadow: 0 4px 12px rgba(0, 0, 0, 0.08);
	}

	.g-contact-settings__add-menu-item {
		display: block;
		width: 100%;
		padding: 6px 16px;
		border: none;
		background: transparent;
		font-size: 14px;
		color: #333;
		line-height: 1.4;
		text-align: left;
		cursor: pointer;
		outline: none;

		&:hover {
			background: #f5fbf8;
			color: #285af9;
		}
	}

	.g-contact-settings__remove {
		flex-shrink: 0;
		padding: 0;
		border: none;
		background: transparent;
		font-size: 13px;
		color: #999;
		cursor: pointer;
		outline: none;

		&:hover {
			color: #ff4d4f;
		}
	}

	.g-contact-settings__footer {
		display: flex;
		justify-content: flex-end;
		flex-shrink: 0;
		margin-top: 24px;
		padding-top: 16px;
		border-top: 1px solid #f0f0f0;
	}

	.g-contact-settings__footer-actions {
		display: flex;
		gap: 10px;
	}

	.g-contact-settings__btn {
		min-width: 72px;
		height: 32px;
		padding: 0 16px;
		border-radius: 4px;
		font-size: 14px;
		cursor: pointer;
		outline: none;

		&.is-cancel {
			border: 1px solid #d9d9d9;
			background: #fff;
			color: #333;

			&:hover {
				color: #5280ff;
    			border-color: #5280ff;
			}
		}

		&.is-confirm {
			border: none;
			background: #285af9;
			color: #fff;

			&:hover {
				background: #3868ff;
			}
		}
	}
</style>

<style lang="less">
	.g-contact-settings-modal {
		.ant-modal-body {
			padding: 20px 24px 18px;
		}
	}
</style>
